import { useMemo } from 'react';

export const useMemoObject = (obj) => useMemo(() => obj, Object.values(obj));